import { render } from "./header-workspace.html?vue&type=template&id=a717af98&scoped=true&ts=true"
import script from "./header-workspace.ts?vue&type=script&lang=ts"
export * from "./header-workspace.ts?vue&type=script&lang=ts"

import "./header-workspace.scss?vue&type=style&index=0&id=a717af98&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a717af98"]])

export default __exports__